(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/dropRight', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/dropRight'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.dropRight, global.convert);
    global.dropRight = mod.exports;
  }
})(this, function (exports, _dropRight2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.dropRight = undefined;

  var _dropRight3 = _interopRequireDefault(_dropRight2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array dropping one or several elements at the end of the former array.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {number} [n=1] The number of elements to drop.
   * @return {Object} Returns the updated object.
   * @example dropRight({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', 2) // => { nested: { prop: [1, 2] } }
   * @see {@link https://lodash.com/docs#dropRight|lodash.dropRight} for more information.
   * @since 0.3.0
   */
  var dropRight = (0, _convert.convert)(_dropRight3.default);
  exports.dropRight = dropRight;
  exports.default = dropRight;
});